// Constants for theater preferences
import { TranslateFunction } from '@/utils/translate/translate-client'

// Define the days of the week with translation keys
export const getDaysOfWeek = (t: TranslateFunction) => [
  { id: 'MON', label: t('dayMonday', 'Monday') },
  { id: 'TUE', label: t('dayTuesday', 'Tuesday') },
  { id: 'WED', label: t('dayWednesday', 'Wednesday') },
  { id: 'THU', label: t('dayThursday', 'Thursday') },
  { id: 'FRI', label: t('dayFriday', 'Friday') },
  { id: 'SAT', label: t('daySaturday', 'Saturday') },
  { id: 'SUN', label: t('daySunday', 'Sunday') },
]

// Define common time windows with translation keys
export const getTimeWindows = (t: TranslateFunction) => [
  { id: 'morning', label: t('timeMorning', 'Morning (9AM-12PM)'), startTime: '09:00', endTime: '12:00' },
  { id: 'afternoon', label: t('timeAfternoon', 'Afternoon (12PM-5PM)'), startTime: '12:00', endTime: '17:00' },
  { id: 'evening', label: t('timeEvening', 'Evening (5PM-8PM)'), startTime: '17:00', endTime: '20:00' },
  { id: 'night', label: t('timeNight', 'Night (8PM-12AM)'), startTime: '20:00', endTime: '23:59' },
]

// Legacy exports for backward compatibility (deprecated)
export const DAYS_OF_WEEK = [
  { id: 'MON', label: 'Monday' },
  { id: 'TUE', label: 'Tuesday' },
  { id: 'WED', label: 'Wednesday' },
  { id: 'THU', label: 'Thursday' },
  { id: 'FRI', label: 'Friday' },
  { id: 'SAT', label: 'Saturday' },
  { id: 'SUN', label: 'Sunday' },
]

export const TIME_WINDOWS = [
  { id: 'morning', label: 'Morning (9AM-12PM)', startTime: '09:00', endTime: '12:00' },
  { id: 'afternoon', label: 'Afternoon (12PM-5PM)', startTime: '12:00', endTime: '17:00' },
  { id: 'evening', label: 'Evening (5PM-8PM)', startTime: '17:00', endTime: '20:00' },
  { id: 'night', label: 'Night (8PM-12AM)', startTime: '20:00', endTime: '23:59' },
]
